export const bultenler = [
  {
    title: 'Ocak - Şubat Ayı Bültenimiz Değerler Eğitimi',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/232201993559931.pdf',
  },
  {
    title: 'Sorumluluk Bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/8122018175732835.pdf',
  },
  {
    title: 'Sevgi ve Saygı Değeri Ekim Ayı Bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/12112018171921672.pdf',
  },
  {
    title: 'ARKADAŞLIK VELİ BÜLTENİ',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/2112018152550661.pdf',
  },
  {
    title: 'Anadolu Lisesi Rehberlik Bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/17102018115342672.pdf',
  },
  {
    title: 'Ortaokul Rehberlik Bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/17102018111242532.pdf',
  },
  {
    title: 'İlkokul Rehberlik Bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/17102018111741314.pdf',
  },
  {
    title: 'OKULA MERHABA',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/1710201811240830.pdf',
  },
  {
    title: '60 - 66 AY GELİŞİM ÖZELLİKLERİ',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/17102018115838549.pdf',
  },
  {
    title: '48 - 60 AY GELİŞİM ÖZELLİKLERİ',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/17102018114736191.pdf',
  },
  {
    title: '36 - 48 AY GELİŞİM ÖZELLİKLERİ',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/17102018111735598.pdf',
  },
  {
    title: 'Eylül Ayı Haber Bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/5102017191440265.pdf',
  },

   {
    title: 'VELİ BİLGİLENDİRME KİTAPÇIĞI 1.2.3. VE 4. SINIFLAR',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/1562017104834760.pdf',
  },
  {
    title: '1. Sınıflar 2. Veli Bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/2122017145110686.pdf',
  },
  {
    title: 'Aralık Ayı Haber bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/191201710344980.pdf',
  },
  {
    title: 'Kasım Ayı Haber bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/6122016145334791.pdf',
  },
  {
    title: 'Ekim Ayı Haber bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/3112016132256836.pdf',
  },
  {
    title: '1. Sınıflar 1. Veli Bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/3112016132745834.pdf',
  },
  {
    title: 'Eylül Ayı Haber bülteni',
    image: 'images2/img2_files/logo.jpg',
    link: '/pdfs/3112016111646429.pdf',
  },
];
